import { VoucherCodeTypes } from '../enums';

export interface CheckoutResponseModel {
  state: CheckOutState;
  orderId?: number;
}

export interface CheckoutVoucherResponseModel extends CheckoutResponseModel {
  codeType?: VoucherCodeTypes;
  codeIntId?: number;
}

export enum CheckOutState {
  Placed = 1,
  Failed = 2,
  RedirectToPaymentProcessor = 3,
  Duplicate = 4,
}

export interface InvoicingAddressModel {
  countyId: number;
  cityId: number;
  addressLine: string;
  agreeCnp: boolean;
  cnp: string | null;
  updateCustomerInvoicingAddress: boolean;
}
